import React from 'react';
import Card from '../../Card';
import DetailRow from '../../DetailRow';
import EditPencil from '../edit/EditPencil';
import { studentTagLabels, TAG_KINDS } from '../../../domain/tags';
import { useDateFormat } from '../../../context/LocaleContext';
import { shortDateOrStored, studentTypeLabel } from '../columns';
import s from './tabs.module.css';

// `timeZone` is the family's — one zone per account, as MMS models it (see
// domain/people.js) — drawn as a subtitle under the card heading, where MMS
// puts it:
//
//     Student Details
//     Timezone: (UTC-08:00) Pacific Time (US & Canada)
//
// The lowercase one-word "Timezone:" is MMS's spelling on this surface,
// although its form labels say "Time Zone". Shown whether or not the family
// has chosen one, resolving to the studio's, so nobody wonders which clock
// this profile's times are in; absent only when the studio has never set a
// zone.
//
// The two tag rows read the managed records and the student's own legacy
// strings, folded (`studentTagLabels` in domain/tags.js, #138), so a student
// not yet migrated still shows their tags.
//
// No Email, Phone or Preferences: MMS's card shows the student's own address,
// number and lesson reminder ticks, and here a student is not a message
// destination (#792). The family's contacts carry all three, on the Family
// Contacts tab.
export default function StudentDetailsTab({ student, timeZone = null, tags = [], onEdit = null }) {
  const tagRow = (kind) => studentTagLabels(student, tags, kind).join(', ') || '–';
  // The studio's short date and the type's label, not the stored strings
  // (#587), as both phones draw these two rows.
  const formatDate = useDateFormat();

  return (
    <Card
      title="Student Details"
      subtitle={timeZone ? `Timezone: ${timeZone}` : null}
      // MMS puts a pencil on this card header that opens a drawer holding the
      // seven fields below plus the family's time zone (#120).
      action={onEdit ? <EditPencil label="Edit Student Details" onClick={onEdit} /> : null}
    >
      <div className={s.detailGrid}>
        <DetailRow label="Instrument Tags" value={tagRow(TAG_KINDS.instrument)} />
        <DetailRow label="Skill Level" value={student.skillLevel} />
        <DetailRow label="Group Tags" value={tagRow(TAG_KINDS.group)} />
        <DetailRow label="Student Since" value={shortDateOrStored(student.studentSince, formatDate)} />
        <DetailRow label="School" value={student.school} />
        <DetailRow label="Referrer" value={student.referrer} />
        <DetailRow label="Birthday" value={student.birthday} />
        <DetailRow label="Student Type" value={studentTypeLabel(student.studentType)} />
      </div>
    </Card>
  );
}
